import { getGlobal } from '~/utils'
import {
  //   Button,
  ContentEditor,
  NavLink,
  SocialChannels,
  Newsletter,
} from '~/components'

const Footer = () => {
  const { site } = getGlobal()

  const legalNav = site?.settings?.legalNavigation
    ? site.navigations.find(e => e._id == site.settings.legalNavigation._ref)
    : null

  return (
    <>
      <Newsletter />
      <footer className="border-t border-[#476F79] bg-teal-700 px-8 py-10 text-white lg:px-16">
        <div className="container">
          <div>
            {site.global.logo && (
              <img
                src={site.global.logo.asset.url}
                alt={site.global.logo.alt}
                className="mb-6"
              />
            )}
          </div>
          <div className="my-8">
            {site.global.socialChannels && (
              <SocialChannels items={site.global.socialChannels} />
            )}
          </div>
          <div className="mb-6 grid gap-6 md:grid-cols-3 md:gap-10 lg:grid-cols-4">
            <div className="*:text-white">
              {site?.global?.columnOne && (
                <ContentEditor content={site.global.columnOne} />
              )}
            </div>
            <div className="*:text-white">
              {site?.global?.columnTwo && (
                <ContentEditor content={site.global.columnTwo} />
              )}
            </div>
            <div className="*:text-white">
              {site?.global?.columnThree && (
                <ContentEditor content={site.global.columnThree} />
              )}
            </div>
          </div>
          <div className="mb-4 md:flex md:justify-between">
            {legalNav?.items && (
              <ul className="mb-6 md:mb-0 md:flex md:gap-5">
                {legalNav.items.map((e, i) => (
                  <li
                    className="mb-3"
                    key={i}
                  >
                    <NavLink
                      {...e}
                      className="underline"
                    />
                  </li>
                ))}
              </ul>
            )}
          </div>
          <div className="gap-8 lg:flex lg:items-end lg:justify-between xl:gap-20">
            <div className="mb-6 *:text-white lg:mb-0 lg:w-3/5">
              {site?.global?.copyright && (
                <ContentEditor content={site.global.copyright} />
              )}
            </div>
            <div className="lg:w-2/5">
              {site.global.legalImages && (
                <div className="flex flex-wrap justify-between gap-4 *:text-white md:justify-start lg:justify-end">
                  {site.global.legalImages.map((e, i) => (
                    <img
                      src={e.asset.url}
                      alt={e.alt}
                      key={i}
                      className="h-10 md:h-14"
                    />
                  ))}
                </div>
              )}
            </div>
          </div>
        </div>
      </footer>
    </>
  )
}

export default Footer
